import * as angular from 'angular';
import { SearchInputs } from './searchinput/searchinputs';

export * from './navcelleditor';
export * from '@common/navkendo/navitemsgrid';
export * from './navpageitemdockzones';
export * from './navpageitempropertygroup';
export * from './lookup/lookup';
export * from './searchinput/searchinputs';
export * from '@common/navkendo/kutils';

angular.module("infoma.navkendo", [])
.directive("navsearchinput", SearchInputs.Directive);
